module.exports = __webpack_public_path__ + "img/elysium.02fbc058.png";